import { render, staticRenderFns } from "./company-create.vue?vue&type=template&id=15f11d49&"
import script from "./company-create.vue?vue&type=script&lang=js&"
export * from "./company-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports